import { useMemo } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { isInstagramIOSWebview } from '#src/app/shared/utils/userAgent';

export function useIsInstagramIOSWebview(): boolean {
	const utilityContext = useUtilityContext();

	return useMemo(() => {
		try {
			return isInstagramIOSWebview(utilityContext);
		} catch {
			return false;
		}
	}, [utilityContext]);
}
